<template>
  <div class="facebook_auth_app">
    <img src="../assets/img/loading.gif" alt="" />
  </div>
</template>

<script>

import {uni} from '../mixin'

export default {
  name: "facebook_auth_app",
  mixins: [uni],
  methods: {
    getCodeAndToFacebookAuth2Page() {
      const code = this.$route.query.code
      this.uni.postMessage({
        data: {
          action: 'facebookAuthSuccess',
          params: {
            code
          }
        }
      })
    }
  },
  mounted() {
    this.getCodeAndToFacebookAuth2Page()
  },
  watch: {
    $route(to) {
      if (to.path === "/facebook_auth_app") {
        this.getCodeAndToFacebookAuth2Page()
      }
    },
  }
};
</script>

<style scoped lang="less">
@import "../assets/css/public";
</style>



// WEBPACK FOOTER //
// src/view/facebookauth_app.vue